import { BitfStrapiRequestMapper } from '@common/libs/bitforce/core/parsers/strapi-parser';
import { EBitfParsers } from '@enums';

export class AppRequestMapper extends BitfStrapiRequestMapper {
  name = EBitfParsers.BITF_STRAPI_PARSER;
}
